import { ControlAttributeType, } from "@cloudpivot/form/typings";
import { formatterValueToSetStatus, formatterRequiredFormula, } from "@cloudpivot/form/utils";
import baseAttribute from "@cloudpivot/form/src/common/component-base-attribute";
import { StaffSelectorValueType, } from "@cloudpivot/form/src/common/component-schema/complex-control-options";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "visible", "style", "tips", "dataItemName", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [
                "displayFormula",
                "requiredFormula",
                "readonlyFormula",
                "multi",
                "deptVisible",
                "defaultValue",
                "defaultValueType",
                "orgRoot",
                "orgRootValueType",
                "recursive",
                "roles",
                "mappings",
                "dataLinkage"
            ],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: "选人控件" }),
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("@cloudpivot/form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 是否必填
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("@cloudpivot/form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
            },
        },
        dataLinkage: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("@cloudpivot/form/src/common/components/data-linkage.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        //是否多选
        multi: {
            inputMethod: ControlAttributeType.Dropdown,
            value: "true",
            options: {
                list: [
                    {
                        value: "false",
                        label: "单选",
                    },
                    {
                        value: "true",
                        label: "多选",
                    },
                ],
                // fieldDisplay: [["mappings"], []],
                hideField(val) {
                    if (val === "true") {
                        return ["mappings"];
                    }
                    return [];
                },
            },
        },
        //可选类型
        deptVisible: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "all",
                        label: "全部",
                    },
                    {
                        value: "user",
                        label: "用户",
                    },
                    {
                        value: "org",
                        label: "组织",
                    },
                ],
                transaction: ({ attr, attrs, displayFields }) => {
                    const defaultValueType = attrs.find((attrItem) => attrItem.field === "defaultValueType");
                    if (attr.value == "user") {
                        // displayFields.push(...['orgRoot', 'recursive']);
                        defaultValueType.options.list = [
                            {
                                value: "",
                                label: "空",
                            },
                            {
                                value: "originator",
                                label: "发起人",
                            },
                        ];
                    }
                    else if (attr.value == "org") {
                        displayFields.push(...["roles", "mappings"]);
                        defaultValueType.options.list = [
                            {
                                value: "",
                                label: "空",
                            },
                            {
                                value: "originatorDept",
                                label: "发起人部门",
                            },
                        ];
                    }
                },
                callback: (key, attr, attrs, vm) => {
                    vm.updateAttribute(key, "defaultValueType", "");
                },
            },
        },
        defaultValueType: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "UserSelectValueSetting",
            inputComponent: () => import("@cloudpivot/form/src/common/components/user-select-value-setting.vue"),
            options: {
                hideField: ["defaultValue"],
                importModal: (attr, attrs) => {
                    const opts = {};
                    attrs.forEach((attrItem) => {
                        opts[attrItem.field] = attrItem.value;
                    });
                    return opts;
                },
                callback: (key, attr, attrs, vm) => {
                    const val = attr.value === StaffSelectorValueType.None
                        ? attrs.find((a) => a.field === "defaultValue").value
                        : null;
                    vm.updateAttribute(key, "defaultValue", val);
                },
                exportModal: (data, attr, attrs, callback, vm) => {
                    const val = data.type === StaffSelectorValueType.None ? data.value : null;
                    vm.$emit("change", "defaultValue", val);
                    return data.type;
                },
                formatter: (valueType, attrs) => {
                    let text = "";
                    switch (valueType) {
                        case StaffSelectorValueType.None:
                            let staff = attrs.find((a) => a.field === "defaultValue")
                                .value;
                            // staff 可能是任意字符 需要容错处理
                            try {
                                if (staff) {
                                    if (typeof staff === "string") {
                                        staff = JSON.parse(staff);
                                    }
                                    text = staff.map((x) => x.name).join(";");
                                }
                            }
                            catch (e) {
                            }
                            break;
                        case StaffSelectorValueType.Originator:
                            text = "创建人";
                            break;
                        case StaffSelectorValueType.OriginatorDept:
                            text = "创建人部门";
                            break;
                    }
                    return text;
                },
            },
        },
        orgRootValueType: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "UserSelectOrgValueSetting",
            inputComponent: () => import("@cloudpivot/form/src/common/components/user-select-value-setting.vue"),
            options: {
                hideField: ["orgRoot"],
                importModal: (attr, attrs) => {
                    const opts = {};
                    attrs.forEach((attrItem) => {
                        opts[attrItem.field] = attrItem.value;
                    });
                    return opts;
                },
                callback: (key, attr, attrs, vm) => {
                    let val = attrs.find((a) => a.field === "orgRoot").value;
                    vm.updateAttribute(key, "orgRoot", val);
                },
                exportModal: (data, attr, attrs, callback, vm) => {
                    let val = data.value;
                    vm.$emit("change", "orgRoot", val);
                    return data.type;
                },
                formatter: (valueType, attrs) => {
                    let orgRoot = attrs.find((a) => a.field === "orgRoot").value;
                    let text = "";
                    switch (valueType) {
                        case StaffSelectorValueType.None:
                            if (orgRoot) {
                                if (typeof orgRoot === "string") {
                                    orgRoot = JSON.parse(orgRoot);
                                }
                                text = orgRoot.map((x) => x.name).join(";");
                            }
                            break;
                        case StaffSelectorValueType.OriginatorDept:
                            text = "创建人部门";
                            break;
                        case StaffSelectorValueType.Ref:
                            if (typeof orgRoot === "string") {
                                text = orgRoot;
                            }
                            break;
                    }
                    return text;
                },
            },
        },
        roles: {
            inputMethod: ControlAttributeType.Modal,
            attrType: "rolesModel",
            options: {
                callback: (key, attr, attrs, vm) => {
                    let val = attrs.find((a) => a.field === "roles").value;
                    vm.updateAttribute(key, "roles", val);
                },
                exportModal: (data, attr, attrs, callback, vm) => {
                    let val = data.value;
                    vm.$emit("change", "roles", val);
                    return data.value;
                },
                formatter: formatterValueToSetStatus,
            },
        },
        mappings: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("@cloudpivot/form/src/common/components/user-selection-map.vue"),
            options: {},
        },
    },
};
